module.exports = __webpack_public_path__ + "img/list.ae2318fc.png";